import React from 'react'
import FlipBook from './FlipBook'
import useSize from './useSize'
import { browserCheck } from '@ta-interaktiv/browsercheck'

function Wrapper(props) {

  const [ref, size] = useSize()
  const isMobile = browserCheck.isMobile

  const width = isMobile ? props.maxWidth : `min(100%, ${props.maxWidth}px)`
  const height = isMobile ? '100vh' : `100%`

  return (
    <div
      ref={ref}
      style={{
        width: `min(100%, ${props.maxWidth}px)`,
        margin: 'auto'
      }}
    >
      {size ? <FlipBook {...props} width={size.width} /> : null}
    </div>
  )
}

export default Wrapper
